import { useStorage } from '@/store/storage';
const { STORAGE_KEY, get, set, clear } = useStorage();

// 加載指定組的本地數據
export const loadLocalData = async (fn, store, group) => {
	try {
		const serialized = await get(`${STORAGE_KEY}.${group}`);
		console.log(`state, loadLocalData, group=${group}`);

		if (serialized === null) {
			fn(store, group, undefined);
		} else {
			fn(store, group, serialized);
		}
	} catch (error) {
		console.error('state, error loading local data:', error);
		return undefined;
	}
};

// 保存指定組的本地數據
export const saveLocalData = async (group, data) => {
	try {
		const serialized = JSON.stringify({ [group]: data });
		console.log(`state, saveLocalData, group=${group}`);

		await set(`${STORAGE_KEY}.${group}`, serialized);
		return true;
	} catch (error) {
		console.error('state, error saving local data:', error);
		return false;
	}
};

// 清除指定組的本地數據
export const clearLocalData = async () => {
	try {
		await clear();
		console.log(`local data has been cleared.`);
		return true;
	} catch (error) {
		console.error(`error clearing local data`, error);
		return false;
	}
};

// // 加載應用程序的狀態
// export const loadState = async (fn, store) => {
// 	try {
// 		const serializedState = await get('state');
// 		if (serializedState === null) {
// 			fn(undefined);
// 		} else {
// 			fn(store, JSON.parse(serializedState));
// 		}
// 	} catch (error) {
// 		console.error('error loading state:', error);
// 		return undefined;
// 	}
// };

// // 保存應用程序的狀態
// export const saveState = async state => {
// 	try {
// 		const serializedState = JSON.stringify(state);
// 		await set('state', serializedState);
// 		return true;
// 	} catch (error) {
// 		console.error('error saving state:', error);
// 		return false;
// 	}
// };
